import React from 'react';
import { Check, Sparkles } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const DailyCoordinationSection = () => {
  const { t } = useLanguage();
  const activities = t('dailyCoordination.activities');
  const rhythmText = t('dailyCoordination.rhythmText');

  return (
    <section className="py-16 bg-white relative">
      <div className="absolute inset-0 blueprint-grid opacity-30" />
      
      <div className="relative max-w-[1200px] mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#0d1442] mb-4">
            {t('dailyCoordination.title')} <span className="gradient-text">{t('dailyCoordination.titleHighlight')}</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-8">
          {/* Core Activities */}
          <div className="bg-white rounded-2xl p-8 border border-slate-100 shadow-sm">
            <h3 className="text-xl font-bold text-[#0d1442] mb-6">{t('dailyCoordination.coreActivities')}</h3>
            <ul className="space-y-4">
              {Array.isArray(activities) && activities.map((activity) => (
                <li key={activity} className="flex items-start gap-3">
                  <div className="icon-badge p-1.5 rounded-lg mt-0.5 flex-shrink-0">
                    <Check className="w-4 h-4 text-[#1a237e]" />
                  </div>
                  <span className="text-sm text-slate-700">{activity}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Our Approach */}
          <div className="bg-white rounded-2xl p-8 border border-slate-100 shadow-sm">
            <div className="flex items-center gap-3 mb-6">
              <div className="icon-badge p-2 rounded-xl">
                <Sparkles className="w-5 h-5 text-[#1a237e]" />
              </div>
              <h3 className="text-xl font-bold text-[#0d1442]">{t('dailyCoordination.weeklyRhythm')}</h3>
            </div>
            
            <p className="text-slate-700 leading-relaxed">
              {rhythmText}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DailyCoordinationSection;
